import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Certification from "@/pages/Certification";
import StandardPage from "@/pages/StandardPage";
import Pricing from "@/pages/Pricing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Process from "@/pages/Process";
import OCertifikate from "@/pages/OCertifikate";
import HallOfFamePage from "@/pages/HallOfFamePage";
import CertifikatProfile from "@/pages/CertifikatProfile";
import ProgramSauberEko from "@/pages/ProgramSauberEko";
import PreInvestorov from "@/pages/PreInvestorov";
import CiernaListina from "@/pages/CiernaListina";
import PreProfesionalov from "@/pages/PreProfesionalov";
import Metodika from "@/pages/Metodika";
import Admin from "@/pages/Admin";
import Portal from "@/pages/Portal";
import Payment from "@/pages/Payment";
import Vizitka from "@/pages/Vizitka";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/riadiace-centrum" element={<Admin />} />
          <Route path="/ziadost" element={<Portal />} />
          <Route path="/platba" element={<Payment />} />
          <Route path="/vizitka/:slug" element={<Vizitka />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/certification" element={<Certification />} />
            <Route path="/standard" element={<StandardPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/obchodne-podmienky" element={<Terms />} />
            <Route path="/postup" element={<Process />} />
            <Route path="/o-certifikate" element={<OCertifikate />} />
            <Route path="/hall-of-fame" element={<HallOfFamePage />} />
            <Route path="/sien-slavy" element={<HallOfFamePage />} />
            <Route path="/certifikat/:certNo" element={<CertifikatProfile />} />
            <Route path="/program-saubereko" element={<ProgramSauberEko />} />
            <Route path="/pre-investorov" element={<PreInvestorov />} />
            <Route path="/cierna-listina" element={<CiernaListina />} />
            <Route path="/pre-profesionalov" element={<PreProfesionalov />} />
            <Route path="/program" element={<ProgramSauberEko />} />
            <Route path="/metodika" element={<Metodika />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111",
            border: "1px solid rgba(212,175,55,0.4)",
            color: "#fff",
          },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
